
import React, { useState } from 'react';

const JobsView: React.FC = () => {
  const [isCreating, setIsCreating] = useState(false);

  return (
    <div className="space-y-10 pb-10">
      <div className="flex justify-between items-center border-b-4 border-black pb-8">
        <div>
          <h2 className="ymca-brand-font text-7xl tracking-tighter leading-none">RECRUITMENT PORTAL</h2>
          <p className="text-gray-500 font-bold uppercase text-xs tracking-[0.2em] mt-2">Design, post and track vacancies across all One YMCA sites.</p>
        </div>
        <button 
          onClick={() => setIsCreating(true)}
          className="px-10 py-4 bg-black text-white font-black text-xs tracking-widest uppercase hover:bg-gray-800 transition-all"
        >
          POST NEW VACANCY
        </button>
      </div>

      {!isCreating ? (
        <div className="grid grid-cols-1 gap-8">
          <div className="p-12 border-2 border-black border-dashed flex flex-col items-center justify-center space-y-6 bg-gray-50">
            <div className="w-16 h-16 bg-black text-white flex items-center justify-center">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M12 4v16m8-8H4" />
              </svg>
            </div>
            <div className="text-center">
              <h3 className="ymca-brand-font text-4xl">NO ACTIVE DRAFTS</h3>
              <p className="text-gray-500 font-medium max-w-sm">Create a new job posting to start attracting local talent to One YMCA.</p>
            </div>
            <button 
              onClick={() => setIsCreating(true)}
              className="px-8 py-3 bg-black text-white font-black text-xs tracking-widest uppercase"
            >
              START DESIGNING
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white border-2 border-black p-10 space-y-10 animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="flex justify-between items-start">
            <h3 className="ymca-brand-font text-5xl">VACANCY DESIGNER</h3>
            <button onClick={() => setIsCreating(false)} className="text-4xl leading-none">&times;</button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="space-y-6">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">Job Title</label>
                <input type="text" placeholder="e.g. Young Persons Activity Worker" className="w-full p-4 border-2 border-black focus:ring-0 font-bold text-lg" />
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">Location</label>
                  <select className="w-full p-4 border-2 border-black font-bold">
                    <option>Hatfield, Hertfordshire</option>
                    <option>Watford</option>
                    <option>Stevenage</option>
                  </select>
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">Contract Type</label>
                  <select className="w-full p-4 border-2 border-black font-bold">
                    <option>Permanent, Part Time</option>
                    <option>Permanent, Full Time</option>
                    <option>Fixed Term</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">Salary (Annual)</label>
                  <input type="text" placeholder="e.g. £24,705" className="w-full p-4 border-2 border-black font-bold" />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">Hours Per Week</label>
                  <input type="number" placeholder="23" className="w-full p-4 border-2 border-black font-bold" />
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2">The Vacancy (Description)</label>
                <textarea rows={8} className="w-full p-4 border-2 border-black font-medium text-sm leading-relaxed" placeholder="Join our team at One YMCA Housing Services..."></textarea>
              </div>
              <div className="pt-4 flex justify-end space-x-4">
                 <button onClick={() => setIsCreating(false)} className="px-8 py-4 border-2 border-black font-black text-xs tracking-widest uppercase hover:bg-gray-100 transition-all">SAVE DRAFT</button>
                 <button className="px-10 py-4 bg-black text-white font-black text-xs tracking-widest uppercase hover:bg-ymca-orange transition-all">PUBLISH VACANCY</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobsView;
